import { SHOW_ALERT } from '@sm/actions/types';

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = {}, action) {
  switch(action.type) {
  case SHOW_ALERT:
    return (action.payload);
  default:
    return state;
  }
}